import request from "@/CommonDP/utils/request";

export default {
  getCompanyList(prjId) {
    return request.get(`/prjPerson/queryOrgList?prjId=${prjId}`);
  },
};
